import { useLidoSDK } from '.'
import useSWR from 'swr'

type UseWithdrawalBaseDataResult = {
  maxAmount: bigint
  minAmount: bigint
  isPaused: boolean
  isBunker: boolean
  isTurbo: boolean
}

export const useWithdrawalBaseData = () => {
  const { withdraw } = useLidoSDK()

  const { data } = useSWR<UseWithdrawalBaseDataResult>(
    'lido-withdrawals-base-data',
    async () => {
      const [
        minAmount,
        maxAmount,
        isPausedMode,
        isBunkerMode,
        isTurboMode,
      ] = await Promise.all([
        withdraw.views.minStethWithdrawalAmount(),
        withdraw.views.maxStethWithdrawalAmount(),
        withdraw.views.isPaused(),
        withdraw.views.isBunkerModeActive(),
        withdraw.views.isTurboModeActive(),
      ])

      const isPaused = !!isPausedMode
      const isBunker = !!isBunkerMode
      const isTurbo = !!isTurboMode

      return {
        minAmount,
        maxAmount,
        isPaused,
        isBunker,
        isTurbo,
      }
    },
  )

  return {
    ...data,
  }
}
